import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useGlobal from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

const mapState = (store) => {
  return store.modulo.timbrado_sftp.list;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_sftp.list };
};

const FilterButtonType = (props) => {
  const { variant = 'secondary', tipo, text, icon } = props;

  return (
    <Dropdown.Item
      variant={variant}
      eventKey={tipo}
    >
      {!!icon && <FontAwesomeIcon icon={icon} />}
      {text ? ` ${text}` : ''}
    </Dropdown.Item>
  );
};

const TimbradoSftpFilterByType = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { tipo } = state.filters;

  const handleOnSelect = (tipo) => {
    actions.paginate({
      page: 1,
      tipo,
    });
  };

  let title = 'Tipo';

  switch (tipo) {
    case 'xml':
      title = 'XML';
      break;

    case 'txt':
      title = 'TXT';
      break;
    default:
      break;
  }

  return (
    <>
      <Dropdown
        title={title}
        id="timbrado-sftp-by-type"
        className="float-left mr-1"
        onSelect={handleOnSelect}
      >
        <Dropdown.Toggle as={CustomDropdownToggle}>{title}</Dropdown.Toggle>

        <Dropdown.Menu>
          <FilterButtonType
            text="Todos"
            current={tipo}
            tipo=""
          />

          <FilterButtonType
            text="Xml"
            current={tipo}
            tipo="xml"
          />

          <FilterButtonType
            text="Txt"
            current={tipo}
            tipo="txt"
          />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default TimbradoSftpFilterByType;
